// extracted by mini-css-extract-plugin
export default {"title":"styles_title__gnlUV","containerOption":"styles_containerOption__d1p-h"};